<template>



          <RightmoveComponent />



</template>

<script>
import RightmoveComponent from '../components/RightmoveComponent.vue'
export default {
  components: {

      RightmoveComponent
  },
    data() {
    return {

    }
  }
}


</script>

<style scoped>

</style>
